export function formatLastModified(dateString) {
  if (!dateString) return "Unknown";

  try {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) return "Unknown";

    const now = new Date();
    const diffInHours = Math.abs(now - date) / 36e5;

    if (diffInHours < 24) {
      return `Today, ${date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
      })}`;
    } else if (diffInHours < 48) {
      return `Yesterday, ${date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
      })}`;
    } else if (diffInHours < 30 * 24) {
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
    } else {
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    }
  } catch (error) {
    console.error("Error formatting date:", error);
    return "Unknown";
  }
}

export function formatDate(date) {
  if (!date) return "Unknown";

  // If date is a string or number, try to convert it to a Date object
  const d = date instanceof Date ? date : new Date(date);

  // Validate the date
  if (Number.isNaN(d.getTime())) {
    return "Unknown";
  }

  try {
    return new Intl.DateTimeFormat("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    }).format(d);
  } catch (error) {
    console.error("Error formatting date:", error);
    return "Unknown";
  }
}
